


































































import Vue from "vue";
import TableLayout from "@/layouts/TableLayout.vue";
import Edit from "@/components/Storage/Edit.vue";
import Overview from "@/components/Storage/Overflow.vue";
import Info from "@/components/Storage/Info.vue";
import { Header } from "@/components/MyTable.vue";
import { axios } from "@/plugins";

const TableHeader: Header[] = [
  { title: "名称", minWidth: 220 },
  { title: "类型", minWidth: 150 },
  { title: "供应者", minWidth: 200 },
  { title: "是否默认", minWidth: 120 },
  { title: "创建时间", minWidth: 200 },
  { title: "操作", width: 80 }
];

export default Vue.extend({
  name: "Storage",
  components: { TableLayout, Edit, Overview, Info },
  props: { tenantId: { type: String } },
  data() {
    return {
      TableHeader,
      loading: false,
      disabled: false,
      tableData: [] as any[],
      selectColumn: [] as any[]
    };
  },
  mounted() {
    this.getTable();
  },
  methods: {
    setRouter(data: any) {
      (this.$refs.overview as any).show(data);
    },
    getTable() {
      this.loading = true;

      axios
        .get(`/storageclass/${this.tenantId}`)
        .then(res => {
          this.tableData = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    columnSelect(data: any[]) {
      this.selectColumn = data;
    },
    create(data: any) {
      (this.$refs.edit as any).show(data);
    },
    isDeleteable() {
      if (this.selectColumn.length === 0) {
        this.$message.error("请先选择存储卷");
        return false;
      }
      const hasDefaultStorage = this.selectColumn.some(item =>
        this.isDefault(item)
      );
      if (hasDefaultStorage) {
        this.$message.error("选中的存储包含默认存储卷");
        return false;
      }
      return this.selectColumn.map(item => {
        return {
          type: item.metadata.annotations["appmgr.sc.type"],
          storageClassName: item.metadata.name
        };
      });
    },
    showInfo(data: any) {
      (this.$refs.info as any).show(data);
    },
    handleCommand(type: string, data: any) {
      switch (type) {
        case "pvc":
          this.setRouter(data);
          break;

        case "info":
          this.showInfo(data);
          break;

        case "delete":
          this.del(
            data.metadata.annotations["appmgr.sc.type"],
            data.metadata.name
          );
          break;
      }
    },
    del(type: string, storageClassName: string) {
      // const falseOrArr = this.isDeleteable();
      // if (!falseOrArr) {
      //   return;
      // }
      this.$confirms({ title: "删除存储卷" }).then(() => {
        axios
          .delete(`/storageclass/${this.tenantId}`, {
            data: [
              {
                type,
                storageClassName
              }
            ]
          })
          .then(() => {
            this.$message.success("存储卷删除成功");
            this.getTable();
          });
      });
    },
    isDefault(data: any) {
      if (
        Object.hasOwnProperty.call(
          data.metadata.annotations,
          "storageclass.kubernetes.io/is-default-class"
        )
      ) {
        return true;
      }
      return false;
    }
  }
});
